import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import TrashCanIcon from "../../../../../../assets/icons/TrashCanIcon";
import InlineIconButton from "../../../../../Buttons/InlineIconButton/InlineIconButton";
import StyledTooltip from "../../../../../StyledTooltip/StyledTooltip";

export default function ExpireCapacityAction({ userIdMcld, originPoint, lane, actionCallback }) {
  return (
    <StyledTooltip title="Expire">
      <Box>
        <InlineIconButton
          onClick={() => actionCallback({ action: "expire-capacity", userIdMcld: userIdMcld, originPoint: originPoint, selectedLanes: [lane] })}
          icon={TrashCanIcon}
          buttonColor="blue"
        />
      </Box>
    </StyledTooltip>
  );
}

ExpireCapacityAction.propTypes = {
  userIdMcld: PropTypes.string,
  originPoint: PropTypes.string,
  lane: PropTypes.object.isRequired,
  actionCallback: PropTypes.func.isRequired
};